import { dayjs } from "client-server-shared/utils/dayjs";

const bfDate = "2024-01-02T23:31:47.983Z";
export const oneWeekAfter = dayjs(bfDate).add(6, "day").toISOString();
